import '../../../FE/src/assets/javascripts/libs/slick.js';

export default class HeroBannerHome {
  constructor(el) {
    this.$this = $(el);
    this.$slider = this.$this.find('.gg-hero-banner-home__slider');
    this.$pauseBtn = this.$this.find('.gg-hero-banner-home__pause-btn');
    this.isPlaying = true;
    this.speedAutoplay = this.$this.data('speed-autoplay');
  }

  init() {
    this.addSlider();
    this.bindEvents();
  }

  addSlider() {
    this.$slider.slick({
      rows: 0,
      slide: '.gg-hero-banner-home__card',
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: this.speedAutoplay * 1000,
      appendArrows: this.$this.find('.slick-controls'),
      appendDots: this.$this.find('.slick-controls'),
      prevArrow: `
        <button type="button" class="slick-prev gg-slick-arrow">
          <span class="icomoon icon-arrow-left"></span>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next gg-slick-arrow">
         <span class="icomoon icon-arrow-right"></span>
        </button>
      `,
    });
  }

  bindEvents() {
    // Pause/Play button
    if (this.$pauseBtn.length) {
      this.$pauseBtn.on('click', () => {
        this.isPlaying = !this.isPlaying;
        if (this.isPlaying) {
          this.$slider.slick('slickPlay');
          this.$pauseBtn.html(`
            <span class="icomoon icon-pause"></span>
          `);
          this.$pauseBtn.attr('aria-label', 'Pause slider');
        } else {
          this.$slider.slick('slickPause');
          this.$pauseBtn.html(`
            <span class="icomoon icon-play"></span>
          `);
          this.$pauseBtn.attr('aria-label', 'Play slider');
        }
      });
    }

    // Pause on hover
    this.$slider.on('mouseenter', () => {
      this.$slider.slick('slickPause');
    });

    this.$slider.on('mouseleave', () => {
      if (this.isPlaying) {
        this.$slider.slick('slickPlay');
      }
    });
  }
}

// Initialize on page load
if (typeof window.acf === 'undefined') {
  $('.gg-hero-banner-home').each((_index, el) => {
    new HeroBannerHome(el).init();
  });
}
